export const enum ScheduleEventType {
  SCHEDULE_EVENT_TYPE_REMEDY = '治療に関すること',
  SCHEDULE_EVENT_TYPE_LIFE = '生活に関すること',
  SCHEDULE_EVENT_TYPE_DUTY = '業務に関すること',
  SCHEDULE_EVENT_TYPE_DIALYSIS = '透析に関すること'
}

export const SCHEDULE_EVENT_TYPE_CSS = {
  [ScheduleEventType.SCHEDULE_EVENT_TYPE_REMEDY]: 'type_bg_red',
  [ScheduleEventType.SCHEDULE_EVENT_TYPE_LIFE]: 'type_bg_blue',
  [ScheduleEventType.SCHEDULE_EVENT_TYPE_DUTY]: 'type_bg_green',
  [ScheduleEventType.SCHEDULE_EVENT_TYPE_DIALYSIS]: 'type_bg_orange'
}
